import { Grid } from "@mui/material";
import React from "react";
import TitleAndDetailExtract from "../ModalTitleAndDetail/ModalTitleAndDetail";
import { DetailInputsModalProps } from "../ModalExtractContent/ModalExtractContent";

interface ModalOrderDetailsHeaderProps {
  icon: React.ReactNode;
  distributor: DetailInputsModalProps;
  requestNumber: DetailInputsModalProps;
  requestDate: DetailInputsModalProps;
  subsidiary: DetailInputsModalProps;
}

const ModalOrderDetailsHeader: React.FC<ModalOrderDetailsHeaderProps> = ({
  icon,
  distributor,
  requestDate,
  subsidiary,
  requestNumber,
}) => {
  return (
    <Grid container padding={2} paddingLeft={0} paddingTop={1}>
      <Grid container alignItems={"center"}>
        <Grid
          item
          xs={6}
          sm={4}
          md={1}
          display={"flex"}
          justifyContent={"left"}
        >
          {icon}
        </Grid>
        <Grid item xs={6} sm={4} md={5} display={"flex"} alignItems={"center"}>
          <TitleAndDetailExtract
            title={distributor.title}
            detail={distributor.value}
            textAlign={"left"}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={4}
          md={2}
          display={"flex"}
          justifyContent={"right"}
        >
          <TitleAndDetailExtract
            title={subsidiary.title}
            detail={subsidiary.value}
            textAlign={"right"}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={4}
          md={2}
          display={"flex"}
          justifyContent={"right"}
        >
          <TitleAndDetailExtract
            title={requestNumber.title}
            detail={requestNumber.value}
            textAlign={"right"}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={4}
          md={2}
          display={"flex"}
          justifyContent={"right"}
        >
          <TitleAndDetailExtract
            title={requestDate.title}
            detail={requestDate.value}
            textAlign={"right"}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalOrderDetailsHeader;
